import { parseBenchmarkDesignMode } from "./parseBenchmarkDesignMode";

/*
 * TEMPORARY DESIGN MODE — bootstrap visual review only.
 *
 * When enabled, BENCHMARK_DESIGN_MODE unlocks a narrow set of frontend page
 * views for localhost design/bootstrap work. It does NOT authenticate users,
 * issue sessions, or authorize backend mutations.
 *
 * Publisher Dashboard and other ownership-sensitive publisher routes always
 * require a validated publisher session — even while benchmark mode is on.
 *
 * Defaults to false. Enable explicitly via VITE_BENCHMARK_DESIGN_MODE for
 * local design review only. MUST NEVER be enabled in production.
 */
export const BENCHMARK_DESIGN_MODE = parseBenchmarkDesignMode(
  import.meta.env?.VITE_BENCHMARK_DESIGN_MODE,
);

/*
 * Nav paths that remain clickable during benchmark visual review even when the
 * visitor is logged out. Only Screen 6 publish layout review is unlocked here.
 *
 * Publisher Dashboard is intentionally omitted — it must follow real auth state.
 *
 * Log In is intentionally omitted — it is always public and must never appear
 * disabled for returning publishers.
 */
export const BENCHMARK_NAV_UNLOCKED_PATHS = new Set(["/publish-your-app"]);

export function isBenchmarkProtectedRouteBypass(
  pathname: string,
  benchmarkDesignModeEnabled: boolean = BENCHMARK_DESIGN_MODE,
): boolean {
  return (
    benchmarkDesignModeEnabled && BENCHMARK_NAV_UNLOCKED_PATHS.has(pathname)
  );
}
